import {
  AuthService,
  CustomLabel,
  FlexContainer,
  ModalComponent,
  RedButton,
  ToastService,
  UtilityMethods,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import { observer } from "mobx-react";
import React from "react";
import { NavigateFunction } from "react-router-dom";
import { PaymentMethodDescripton } from "../../../shared/components";
import RenderMerchantAccountName from "../../../shared/components/RenderMerchantAccountName";
import { PaymentDetailModel } from "../../../shared/models";
import {  PaymentService } from "../../../shared/services";
import { AccountSettingsStore } from "../../../shared/store";
import {
  DescriptionCell,
  InvoicePopupWrapper,
  LabelCell,
} from "../../../shared/styles";
import { GetPaymentMethodType } from "../../../shared/utils";

type IProps = {
  navigate: NavigateFunction;
  onClose: (refresh: boolean, issueRefund: boolean) => void;
  paymentData: PaymentDetailModel;
};

const VoidPaymentPopUp: React.FC<IProps> = ({ onClose, paymentData }) => {
  const [isAPIRequestPending, setAPIRequestPending] = React.useState(false);
  const [voidPaymentError, setVoidPaymentError] = React.useState("");
  const [issueRefund, setIssueRefund] = React.useState(false);
  function row(label: string, rightSide: React.ReactNode) {
    {
      return (
        <FlexContainer spacing={40}>
          <LabelCell>
            <CustomLabel className="standard-lh text-nowrap">
              {label}
            </CustomLabel>
          </LabelCell>
          <DescriptionCell>{rightSide}</DescriptionCell>
        </FlexContainer>
      );
    }
  }

  function body() {
    return (
      <InvoicePopupWrapper>
        {row(
          "Customer",
          <CustomLabel fontWeight={"600"}>
            {paymentData.contact?.fullName || paymentData.contact?.email}
          </CustomLabel>
        )}
        {row(
          "Merchant Account",
          <RenderMerchantAccountName
            name={paymentData?.merchantAccount?.name || ""}
          />
        )}
        {paymentData.subscriptionId &&
          row(
            "Subscription",
            <CustomLabel>{paymentData.subscriptionName}</CustomLabel>
          )}
        {paymentData.invoiceNumber &&
          row(
            "Invoice",
            <CustomLabel>{paymentData.invoiceNumber}</CustomLabel>
          )}
        {row(
          GetPaymentMethodType(paymentData.paymentMethod.type),
          <PaymentMethodDescripton
            paymentMethod={paymentData.paymentMethod}
            className="void-card"
            hideExpiration={true}
          />
        )}
        {row(
          "Completed Payment",
          <FlexContainer spacing={15} fxLayout="column">
            <CustomLabel fontWeight={600} color="#000">
              ${AccountSettingsStore.formatAmount(paymentData.netAmount)}
              <span className="charcoal-label font-regular"> USD</span>{" "}
            </CustomLabel>{" "}
            <CustomLabel fontWeight={600} color="#000">
              {UtilityMethods.formatDateInString(paymentData.dueDate)} ,
              {UtilityMethods.getHHMMFromDate(paymentData.dueDate)}{" "}
              {UtilityMethods.getAMPMFromDate(paymentData.dueDate)}{" "}
              <CustomLabel>
                {AccountSettingsStore.generalSettings.timeZone.abbreviation ||
                  ""}
              </CustomLabel>
            </CustomLabel>
          </FlexContainer>
        )}
        {voidPaymentError && (
          <CustomLabel
            color="#FF0000"
            fontSize="16px"
            margin="20px 0px 0px 0px"
          >
            {voidPaymentError}
          </CustomLabel>
        )}
      </InvoicePopupWrapper>
    );
  }

  function voidPaymentTransaction() {
    const amount = paymentData.netAmount;
    setAPIRequestPending(true);
    PaymentService.voidPayment(
      paymentData?.id || "",
      AuthService.authData.accountId
    ).subscribe({
      next: (response) => {
        setAPIRequestPending(false);
        if (response.result.success) {
          ToastService.showSuccess("Payment voided successfully");
          onClose(true, false);
        } else {
          switch (response.result.failureReason) {
            case "AmountRefunded":
            case "GatewayError":
              setIssueRefund(true);
              setVoidPaymentError(
                `Your payment for $${AccountSettingsStore.formatAmount(amount)} could not be voided. You can issue a refund instead.`
              );
              break;
          }
          ToastService.showError("Error in voiding payment");
        }
      },
      error: () => {
        ToastService.showError("Error in voiding payment");
      },
    });
  }

  return (
    <ModalComponent
      title={"Void Payment"}
      titleFontSize="20px"
      bodyPadding="40px 45px"
      onClose={() => onClose && onClose(false, issueRefund)}
      showFooter={true}
      wrapperWidth="650px"
      bodyBackgroundColor="#fff"
      footerBackground="rgba(255, 0, 0, 0.1)"
      redHeader={true}
      blueHeader={false}
      footerHeight="auto"
      footerContent={
        <FlexContainer alignItems="center" justifyContent="center" spacing={15}>
          <RedButton
            minWidth="120px"
            height="30px"
            onClick={() => onClose(false, issueRefund)}
          >
            Keep Payment
          </RedButton>
          <RedButton
            disabled={isAPIRequestPending}
            primary
            minWidth="120px"
            height="30px"
            onClick={() => voidPaymentTransaction()}
          >
            Void Payment
          </RedButton>
        </FlexContainer>
      }
    >
      {body()}
    </ModalComponent>
  );
};

export default withRouter(observer(VoidPaymentPopUp));
